import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { IWidget, OverdueSitesWidget } from "src/app/models/dashboard";
import { WidgetComponent } from 'src/app/views/dashboard/widgets/widget/widget.component';
import { Dashboard, OverdueSite } from 'src/api/models';
import { SiteTwinService, SiteTypeService } from 'src/api/services';

@Component({
  selector: 'app-overdue-sites-widget',
  templateUrl: './overdue-sites-widget.component.html',
  styleUrls: ['./overdue-sites-widget.component.css']
})
export class OverdueSitesWidgetComponent implements OnInit, IWidget {
  @Output() dashboardSelected = new EventEmitter<any>();
  @Output() widgetSelected = new EventEmitter<any>();
  
  state:any;
  widgetComponent: WidgetComponent;
  widget: OverdueSitesWidget;
  dashboard: Dashboard;
  uri: string;

  overdueSites: OverdueSite[];

  loadComplete(){
    
  }
  
  constructor(private siteTwinService: SiteTypeService) {
  }

  ngOnInit() {
    this.refresh();
  }

   refresh() {
    // fetch the overdue sites details from service
    this.siteTwinService.SiteTypeGetOverdueSites({customerId:this.dashboard.customerId, siteTypeCode: this.widget.siteTypeCode, minThresholdHours: this.widget.minThresholdHours, maxThresholdDays: this.widget.maxThresholdDays}).subscribe(result => {
      this.overdueSites = result;
    });
  }

}
